import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./TransactionsPage.css";

function TransactionsPage() {
  const location = useLocation();
  const user = location.state?.user || {};
  const [activeTab, setActiveTab] = useState("vouchers");
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    if (user.user_id) {
      fetch(`/api/user-voucher-history/${user.user_id}`)
        .then((res) => res.json())
        .then((data) => {
          setTransactions(data.history || []);
        })
        .catch((err) => console.error("Error fetching transactions:", err));
    }
  }, [user]);

  return (
    <div className="transactions-page">
      <div className="header">
        <button onClick={() => window.history.back()} className="back-btn">←</button>
        <h2>Transactions</h2>
      </div>

      {/* Tabbed Navigation */}
      <div className="tabs">
        <button className={activeTab === "payments" ? "active" : ""} onClick={() => setActiveTab("payments")}>
          Payment
        </button>
        <button className={activeTab === "vouchers" ? "active" : ""} onClick={() => setActiveTab("vouchers")}>
          Vouchers
        </button>
      </div>

      {/* Transactions List */}
      {activeTab === "vouchers" && (
        <div className="transaction-list">
          {transactions.length > 0 ? (
            transactions.map((txn, index) => (
              <div key={index} className="transaction-item">
                <img
                    src={txn.voucher_image  ? `https://www.bleusea.com${txn.voucher_image}` : "/fallback-image.jpg"}
                    alt="Voucher"
                    className="voucher-image"
                    onError={(e) => { e.target.src = "/fallback-image.jpg"; }} // 🛠 Debugging
                  />

                <div className="transaction-info">
                  <p><strong>{txn.description}</strong></p>
                  <p>Value: {txn.voucher_value}</p>
                  <p>
                    {txn.redeemed
                      ? `Redeemed on: ${new Date(txn.redeemed_date).toLocaleString()}`
                      : `Issued on: ${new Date(txn.issue_date).toLocaleString()}`}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <div className="empty-state">
              <img src="/images/empty-transactions.png" alt="No transactions" />
              <p>No Voucher purchases to show yet</p>
              <p>When you make a Voucher purchase, your successful payments will show here.</p>
              <button className="buy-btn">Buy Vouchers</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default TransactionsPage;
